import {Component, Inject} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {AlertService, AuthenticationService,} from '../../_services/index';
import {DynamicDialogConfig, DynamicDialogRef} from "primeng/dynamicdialog";

@Component({
  standalone: false,
  selector: 'inspection-result-popup-component',
  templateUrl: 'inspectionResultsPopup.component.html'
})

export class InspectionResultsPopupComponent {
  constructor(
    public dialogRef: DynamicDialogRef,
    public config: DynamicDialogConfig,
    public router: Router,
    public route: ActivatedRoute,
    public alertService: AlertService,
    public authenticationService: AuthenticationService) {
  }

  onLogOff(): void {
    this.dialogRef.close();
    this.authenticationService.logout();
  }

  onClose(): void {
    this.dialogRef.close();
  }

  format(operator, path, expected, found) {
    switch (operator) {
      case 'Equals':
        return `${path} not equal to ${found}`;
      case 'NotEquals':
        return `${path} equals to ${found}`;
      case 'Contains':
        return `${path} does not contain ${expected}`;
      case 'NotContains':
        return `${path} contains ${expected}`;
      case 'Greater':
        return `${path} is not greater than ${found}`;
      case 'Less':
        return `${path} is not less than ${found}`;
    }
    return '';
  }
}
